/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Force_Unlock_ConfirmInputs */

const cs_workflow_force_unlock_confirm = /** @type {(inputs: Workflow_Force_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převzít zámek? Tento workflow upravuje jiný uživatel.`)
};

const en_workflow_force_unlock_confirm = /** @type {(inputs: Workflow_Force_Unlock_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take over the lock? Another user is editing this workflow.`)
};

/**
* | output |
* | --- |
* | "Take over the lock? Another user is editing this workflow." |
*
* @param {Workflow_Force_Unlock_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_force_unlock_confirm = /** @type {((inputs?: Workflow_Force_Unlock_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Force_Unlock_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_force_unlock_confirm(inputs)
	return cs_workflow_force_unlock_confirm(inputs)
});